interface SectionHeadingProps {
  title: string
  subtitle?: string
  centered?: boolean
  light?: boolean
}

export default function SectionHeading({
  title,
  subtitle,
  centered = true,
  light = false,
}: SectionHeadingProps) {
  return (
    <div className={`mb-12 ${centered ? 'text-center' : ''}`}>
      <h2 className={light ? 'text-white' : 'text-secondary'}>{title}</h2>
      {subtitle && (
        <p className={`mt-3 text-lg ${light ? 'text-gray-300' : 'text-text-secondary'}`}>
          {subtitle}
        </p>
      )}
    </div>
  )
}
